import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "newsletter",
  class: "container position-relative text-center text-light"
}
const _hoisted_2 = {
  class: "d-flex flex-column justify-content-center",
  autocomplete: "on",
  "aria-label": "Subscription form"
}
const _hoisted_3 = { class: "d-flex flex-row align-items-baseline justify-content-center" }
const _hoisted_4 = {
  class: "d-inline-flex col-md-2",
  for: "name"
}
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "d-flex flex-row align-items-baseline justify-content-center" }
const _hoisted_7 = {
  class: "d-inline-flex col-md-2",
  for: "birth"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "d-flex flex-row align-items-baseline justify-content-center" }
const _hoisted_10 = {
  class: "d-inline-flex col-md-2",
  for: "trade"
}
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "d-flex flex-row align-items-baseline justify-content-center" }
const _hoisted_13 = {
  class: "d-inline-flex col-md-2",
  for: "email"
}
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "d-flex flex-row align-items-baseline justify-content-center" }
const _hoisted_16 = {
  class: "d-inline-flex col-md-2",
  for: "phone"
}
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "d-flex flex-row align-items-baseline justify-content-center mt-3" }
const _hoisted_19 = {
  class: "d-inline-flex",
  for: "funding"
}
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.content.newsletter), 1),
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.content.fullname), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
          class: "d-inline-flex col-md-4",
          name: "name",
          type: "text",
          placeholder: _ctx.content.fullname,
          required: ""
        }, null, 8, _hoisted_5), [
          [
            _vModelText,
            _ctx.form.name,
            void 0,
            { lazy: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.content.birthday), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.birth) = $event)),
          class: "d-inline-flex col-md-4",
          name: "birth",
          title: _ctx.content.birthday,
          type: "date",
          min: "1943-01-01",
          max: "2007-12-31"
        }, null, 8, _hoisted_8), [
          [
            _vModelText,
            _ctx.form.birth,
            void 0,
            { lazy: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.content.profession), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.trade) = $event)),
          class: "d-inline-flex col-md-4",
          name: "trade",
          type: "text",
          placeholder: _ctx.content.profession
        }, null, 8, _hoisted_11), [
          [
            _vModelText,
            _ctx.form.trade,
            void 0,
            { lazy: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.content.email), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.email) = $event)),
          class: "d-inline-flex col-md-4",
          name: "email",
          type: "email",
          placeholder: _ctx.content.email,
          required: ""
        }, null, 8, _hoisted_14), [
          [
            _vModelText,
            _ctx.form.email,
            void 0,
            { lazy: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.content.phonenumber), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.phone) = $event)),
          class: "d-inline-flex col-md-4",
          name: "phone",
          type: "tel",
          placeholder: _ctx.content.phonenumber
        }, null, 8, _hoisted_17), [
          [
            _vModelText,
            _ctx.form.phone,
            void 0,
            { lazy: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.funding) = $event)),
          class: "d-inline-flex me-1",
          name: "funding",
          type: "checkbox",
          placeholder: "checked"
        }, null, 512), [
          [
            _vModelCheckbox,
            _ctx.form.funding,
            void 0,
            { lazy: true }
          ]
        ]),
        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.content.funding), 1)
      ]),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.message) = $event)),
        type: "text",
        class: "d-inline-flex align-self-center justify-content-center w-75 p-4 mt-4 mb-2 text-wrap",
        placeholder: _ctx.content.message
      }, null, 8, _hoisted_20), [
        [
          _vModelText,
          _ctx.form.message,
          void 0,
          { lazy: true }
        ]
      ]),
      _createElementVNode("input", {
        type: "button",
        value: _ctx.content.send,
        class: "d-inline-flex align-self-center justify-content-center w-75 btn btn-primary",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, null, 8, _hoisted_21)
    ])
  ]))
}